import { mlApiErrorMessage, mlApiErrorStatus } from "../../api/mlApi";

/**
 * What actually went wrong: the endpoint's own `{"error": "..."}` first, then
 * the status-specific hint, then the raw error. Same pattern as hub_health's
 * own copy -- pages don't share this, by design.
 */
export function errorSubtext(error: unknown): string {
  const apiMessage = mlApiErrorMessage(error);
  if (apiMessage === "forbidden") {
    return "Your Cognito identity isn't on the ML API's tester allowlist yet.";
  }
  if (apiMessage) {
    return apiMessage;
  }

  if (mlApiErrorStatus(error) === 403) {
    return "The request was rejected before it reached the endpoint — check that it's signed through postMlApi.";
  }

  return error instanceof Error
    ? error.message
    : "The response didn't match the expected shape.";
}
